import React from 'react';

import { NativeResources } from '@ariksa/inventory-core/api';

import { Principals } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Identity/Principals/Principals';
import { SnowflakeDatabaseIdentity } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Data/Snowflake/SnowflakeDatabaseIdentity';

export const getIdentityComponent = resourceType => {
  switch (resourceType) {
    case NativeResources.SnowflakeDatabases:
    case NativeResources.SnowflakeTables:
    case NativeResources.SnowflakeSchemas:
      return <SnowflakeDatabaseIdentity />;
    // Every other resource pages its principals from the server.
    default:
      return <Principals />;
  }
};
